import { useQuery } from "@tanstack/react-query";
import { apiBase } from "@/shared/api/client";
import { getOrgSettings } from "@/shared/api/org-settings";
import { queryKeys } from "@/shared/query/keys";
import type { LetterheadPrint } from "./letterhead-print-math";

/** Load org letterhead for DocSlip — plan/43. */
export function useOrgLetterhead(companySlug: string | undefined) {
  const q = useQuery({
    queryKey: queryKeys.org.settings(companySlug ?? ""),
    enabled: Boolean(companySlug),
    queryFn: () => getOrgSettings(companySlug!),
    staleTime: 60_000,
  });

  const org = q.data?.org;
  const letterhead: LetterheadPrint | null = org
    ? {
        tradeName: org.name,
        legalName: org.legalName ?? null,
        addressLine1: org.addressLine1 ?? null,
        addressLine2: org.addressLine2 ?? null,
        city: org.city ?? null,
        province: org.province ?? null,
        postalCode: org.postalCode ?? null,
        countryCode: org.countryCode ?? "PH",
        tin: org.tin ?? null,
        phone: org.phone ?? null,
        email: org.email ?? null,
        website: org.website ?? null,
        registrationNote: org.registrationNote ?? null,
        permitNote: org.permitNote ?? null,
        logoUrl: org.hasLogo
          ? `${apiBase()}/c/${companySlug}/settings/org/logo`
          : null,
      }
    : null;

  return { letterhead, isLoading: q.isLoading };
}
